import React from "react";
import { useSelector } from "react-redux";
import Hidden from "@material-ui/core/Hidden";
import Container from "@material-ui/core/Container";

const TopLogo = () => {
  useSelector((state) => state.settings.brandVersion);
  const roomLogoSrc =
    (window.config &&
      (window.config.logo2 ||
        window.config.logoWhite ||
        window.config.logo1)) ||
    null;

  return (
    <Hidden smUp>
      <Container
        style={{
          position: "absolute",
          right: 0,
          bottom: 22,
          zIndex: 999,
          textAlign: "right",
          padding: 16,
        }}
      >
        {roomLogoSrc && (
          <img
            alt="Logo"
            src={roomLogoSrc}
            style={{ maxHeight: 36, objectFit: "contain" }}
          />
        )}
      </Container>
    </Hidden>
  );
};

export default TopLogo;
